import { RecruiterLeadPayload, RecruiterSearch, RecruiterTalentPayload, RefinedRecruiterSearchPayload } from 'features/co-pilot/co-pilot.types';
import _ from 'lodash';
import Logger from 'logger';
import { API_V1 } from './APIs/APIv1';

export const getRecruiterConstraints = async (
  searchType: string,
  query: string,
  lang: string,
  linkedinAccount: string | undefined
) => {
  try {
    const response = await API_V1.post(
      '/linkedin/lookups/recruiter-constraints',
      {
        linkedinAccount,
      },
      {
        params: {
          searchType,
          query,
          lang,
        },
      }
    );

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting recruiter constraints!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const getRecruiterContacts = async (
  pageNumber: number,
  linkedinAccount: string | undefined,
  baseSearch?: RecruiterTalentPayload | RecruiterLeadPayload,
  refinedSearch?: RefinedRecruiterSearchPayload,
  searchRequestId?: string,
  searchHistoryId?: string,
  searchContextId?: string,
  param?: keyof RecruiterSearch
) => {
  try {
    const response = await API_V1.post('/talent-search/recruiter-contacts', {
      pageNumber,
      linkedinAccount,
      baseSearch,
      refinedSearch,
      searchRequestId,
      searchHistoryId,
      searchContextId,
      param,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting recruiter contacts!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
